import WITH_TEXT_1 from '@/assets/svg/logo/logo-oneslip.svg'

export const WITH_TEXT = [WITH_TEXT_1]

import PH_LOGO from '@/assets/svg/placeholder_clinic_circle_256.svg'

export const LOGO = [PH_LOGO]
